import { createFileRoute } from "@tanstack/react-router";

import ManageColors from "@/components/ManageColors/ManageColors";

export const Route = createFileRoute("/gym/$venueUuid/settings/colors")({
  component: ManageColors,
});
